import { createAppRequest } from '@/services/request';
import { setHrRuntimeContext } from '../state/hrRuntimeContext';

const request = createAppRequest();
const PREFIX = '/bff/zy-hr/context';

export type HrPermission = string;

export type HrContext = {
  tenantUuid: string;
  organizationUuid: string;
  permissions: HrPermission[];
  dataScopes?: {
    resource: string;
    scopeType:
      | 'tenant'
      | 'department'
      | 'department_and_children'
      | 'self'
      | 'custom'
      | 'none';
    source: string;
    targetUuids?: string[];
  }[];
  roles?: {
    uuid: string;
    name: string;
    code?: string;
  }[];
  policySource?: string;
  previewSession?: {
    enabled: boolean;
    previewSession?: string;
    roleUuids: string[];
    roles: {
      uuid: string;
      name: string;
      code?: string;
    }[];
    source: 'local-preview';
  };
};

export async function queryHrContext() {
  const context = await request<HrContext>(PREFIX, {
    method: 'GET',
  });
  setHrRuntimeContext(context);
  return context;
}
